import { GAME_NAME } from 'commons/superApp/models/games';
import { ScreenType } from 'commons/models/referral';

export interface IHappyHourTemplate {
	_id: string;
	bgColor: string;
	ctaBgColor: string;
	ctaDisplayText?: string;
	ctaTextColor: string;
	ctaType: ScreenType;
	ctaValue: ScreenName;
	dividerColor: string;
	endHour: number;
	endTime: number;
	fgUrl: string;
	gameName: GAME_NAME;
	hhType: EHappyHourTypes;
	imageUrl: string;
	isDisabled: boolean;
	marqueeAnimUrl: string;
	marqueeBgColor: string;
	marqueeText: string;
	marqueeTextColor: string;
	marqueeWiggleColor: string;
	priority: number;
	screenName: ScreenName;
	startHour: number;
	startTime: number;
	stripeColor: string;
	stripeUrl: string;
	subtitle: string;
	text1: string;
	text1Color: string;
	text2: string;
	text2Color: string;
	timeText: string;
	timeTextColor: string;
	titleUrl: string;
	createdAt: number;
	updatedAt: number;
}

export enum EHappyHourTypes {
	DEF = 'DEF',
	BONUS_REWARDS = 'BONUS_REWARDS',
	BONUS_PERCENTAGE = 'BONUS_PERCENTAGE'
}

export type THappyHourTemplateWithSort = { sortOrder: number } & IHappyHourTemplate;

export interface IPageInfo {
	pageNo: number;
	pageSize: number;
}

export interface ISortInfo {
	field: string;
	order: 1 | -1;
}

export interface IFilterDetails {
	field: string;
	operator: string;
	value: any;
}

export enum ScreenName {
	REFER = 'REFER',
	SETTINGS = 'SETTINGS',
	PLAY_ONLINE = 'PLAY_ONLINE',
	NOTIFICATION = 'NOTIFICATION',
	PROFILE = 'PROFILE',
	EDIT_PROFILE = 'EDIT_PROFILE',
	REMOVE_AVATAR = 'REMOVE_AVATAR',
	PROFILE_FOLLOW = 'PROFILE_FOLLOW',
	PROFILE_UNFOLLOW = 'PROFILE_UNFOLLOW',
	SOCIAL_COMMUNITY = 'SOCIAL_COMMUNITY',
	GAME_HISTORY = 'GAME_HISTORY',
	SEE_MORE_INFO = 'SEE_MORE_INFO',
	PWF = 'PWF',
	HELPDESK = 'HELPDESK',
	WALLET = 'WALLET',
	MTT_TOURNAMENT = 'MTT_TOURNAMENT',
	CONTEST = 'CONTEST',
	NUDGE = 'NUDGE',
	NX_DETAILS = 'NX_DETAILS',
	NX_SYNC_DETAILS = 'NX_SYNC_DETAILS',
	HOW_TO_PLAY = 'HOW_TO_PLAY',
	TELEGRAM_REFERRAL = 'TELEGRAM_REFERRAL',
	WHATSAPP_SHARE = 'WHATSAPP_SHARE',
	KYC = 'KYC',
	DAILY_CHALLENGE = 'DAILY_CHALLENGE',
	APP_RESTART = 'APP_RESTART',
	ADD_BANK = 'ADD_BANK',
	ADD_UPI = 'ADD_UPI',
	ADD_MONEY = 'ADD_MONEY',
	DASHBOARD = 'DASHBOARD',
	WITHDRAWAL = 'WITHDRAWAL',
	PROFILE_REMOVE = 'PROFILE_REMOVE',
	QUICK_PROFILE = 'QUICK_PROFILE',
	VIEW_PROFILE = 'VIEW_PROFILE',
	VIP = 'VIP',
	FOLLOWERS_LIST_SELF = 'FOLLOWERS_LIST_SELF',
	LEADERBOARD = 'LEADERBOARD',
	SUGGESTIONS = 'SUGGESTIONS',
	FOLLOWINGS_LIST_SELF = 'FOLLOWINGS_LIST_SELF',
	FOLLOWERS_LIST_OTHER = 'FOLLOWERS_LIST_OTHER',
	FOLLOWINGS_LIST_OTHER = 'FOLLOWINGS_LIST_OTHER',
	VIEW_ALL_FRIENDS = 'VIEW_ALL_FRIENDS',
	INITIATE_INVITE = 'INITIATE_INVITE',
	INVITE_LOCKED = 'INVITE_LOCKED',
	FREE_LIMIT_EXCEEDED = 'FREE_LIMIT_EXCEEDED',
	SPOTLIGHT = 'SPOTLIGHT',
	SIGNUP = 'SIGNUP',
	PLAY_WIN = 'PLAY_WIN',
	NX_GAME_HISTORY = 'NX_GAME_HISTORY',
	SOCIAL_EDIT_PROFILE = 'SOCIAL_EDIT_PROFILE'
}
